@if (groupData) {
    <div class="drawer-link-group">
        <finder-component-header
            [data]="groupData">
        </finder-component-header>
        <ul class="drawer-links">
            @for (drawer of groupData.drawerGroup; track drawer.linkId) {
            <li class="drawer-link-item">
                <finder-campaign-drawer-link
                    [drawerData]="drawer.data"
                    [linkId]="drawer.linkId">
                </finder-campaign-drawer-link>
            </li>
            }
        </ul>
    </div>
}
